import { createAsyncThunk } from '@reduxjs/toolkit'
import { wikiAPI } from '../../utils/supabase'

// === SEARCH THUNKS ===

export const searchPages = createAsyncThunk(
  'wiki/searchPages',
  async ({ userId, query }, { rejectWithValue }) => {
    const { data, error } = await wikiAPI.searchPages(userId, query)
    if (error) return rejectWithValue(error.message)
    return data
  }
)
